import { useContext } from 'react';
import { Feature } from '../../../constants/Feature';
import { FeatureOnboardingContext } from './FeatureOnboardProvider';
import {
  IFeatureOnboarding,
  IFeatureOnboardingContext,
  TOnboardingFeatures,
  TOnboardingStep,
} from './useFeatureOnboarding.types';

const onboardingStepsMap: { [key in Feature]: TOnboardingFeatures } = {
  [Feature.Boards]: 'boardsFeatureOnboarding',
};

export const useOnboardingFeature = <S extends TOnboardingStep>(feature: Feature): IFeatureOnboarding<S> =>
  useContext<IFeatureOnboardingContext>(FeatureOnboardingContext)[onboardingStepsMap[feature]];
